import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { TipHeading } from "./TipHeading";
import { TipText } from "./TipText";
export const SixthTip = (param)=>{
    let { children , headingClassName  } = param;
    return /*#__PURE__*/ _jsxs("article", {
        className: "min-w-[300px]",
        children: [
            children,
            /*#__PURE__*/ _jsx(TipHeading, {
                className: headingClassName,
                children: "Follow individual park guidelines"
            }),
            /*#__PURE__*/ _jsx(TipText, {
                children: "Videos that depict irresponsible behavior will not be permitted."
            })
        ]
    });
};
